module.exports = __webpack_public_path__ + "static/Healthcare-IOT-66b66f0d6e8f9b28a877ca577f235c40.jpg";